(function () {
	'use strict';

	angular.module('mx.components').directive('mxDisableWatchersIf', [
		function mxDisableWatchersIfDirective() {
			return {
				restrict: 'A',
				scope: true,
				link: function (scope, element, attrs) {
					scope.$parent.$watch(attrs.mxDisableWatchersIf, function (disable, oldDisable) {
						if (typeof disable !== 'boolean' || disable === oldDisable) {
							return;
						}

						var pendingChildHeads = [scope];
						var currentScope;
						while (pendingChildHeads.length) {
							currentScope = pendingChildHeads.shift();
							while (currentScope) {
								if (disable === true && currentScope.$$watchers && currentScope.$$watchers.length > 0) {
									currentScope.__mx__$$watchers = currentScope.$$watchers;
									currentScope.$$watchers = [];
									if (currentScope.__mx__$$watchers.$$digestWatchIndex) {
										currentScope.$$watchers.$$digestWatchIndex = currentScope.__mx__$$watchers.$$digestWatchIndex;
									}
								}
								if (disable === false && currentScope.__mx__$$watchers) {
									currentScope.$$watchers = currentScope.__mx__$$watchers;
									delete currentScope.__mx__$$watchers;
								}

								pendingChildHeads.push(currentScope.$$childHead);
								currentScope = currentScope.$$nextSibling;
							}
						}

						element[disable ? 'addClass' : 'removeClass']('ng-hide');
					});
				},
			};
		},
	]);
})();
